function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { responseMapper } from "../../helpers/responseMapper";
import { instance } from "../instance";
export const deleteNotification = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator(function* (_ref) {
    let from = _ref.from,
        to = _ref.to;
    yield instance.post('notifications/deletenotification', {
      idReceiverUser: to,
      notificationBody: from
    });
    return true;
  });

  return function deleteNotification(_x) {
    return _ref2.apply(this, arguments);
  };
}();
const getNotificationsResponseTemplate = {
  code: 'headerResponse.code',
  payload: ['payload.notifications', {
    id: '_id',
    username: 'user_name',
    name: 'name',
    eventId: 'event',
    email: 'email',
    position: 'position',
    description: 'description',
    phone: 'phone',
    company: 'company'
  }]
};
export const getNotifications = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* (_ref3) {
    let userId = _ref3.userId;
    const response = yield instance.post('notifications/getnotifications', {
      idReceiverUser: userId
    });

    const _responseMapper = responseMapper({
      template: getNotificationsResponseTemplate,
      data: response.data
    }),
          code = _responseMapper.code,
          payload = _responseMapper.payload;

    if (code !== 200) throw new Error('Hubo un error al obtener las notificaciones');
    return payload;
  });

  return function getNotifications(_x2) {
    return _ref4.apply(this, arguments);
  };
}();